// extracted by mini-css-extract-plugin
module.exports = {"table":"Result_table__2Paak","tableRow":"Result_tableRow__1fCLG","tableHeader":"Result_tableHeader__2u4io","links":"Result_links__vUVgy"};